export class Assessment {
  id: string;
  name: string;
  description: string;
  totalQuestions: number;
  threshold?: number;
  hasLesson: boolean;
  isCertifying: boolean;
  status: string;
  constructor(assessment?: Partial<Assessment>) {
    Object.assign(this, assessment);
  }
}
